import script from "./sp-results.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sp-results.vue?vue&type=script&setup=true&lang=ts"
export * from "./sp-results.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./sp-results.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__